import { render, staticRenderFns } from "./TopNavBar.vue?vue&type=template&id=58c96196&scoped=true&"
import script from "./TopNavBar.vue?vue&type=script&lang=js&"
export * from "./TopNavBar.vue?vue&type=script&lang=js&"
import style0 from "./TopNavBar.vue?vue&type=style&index=0&id=58c96196&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58c96196",
  null
  
)

export default component.exports